// import { useState } from "react";
// import { Link } from "react-router-dom";
// import { Skeleton } from "@mui/material";

// const ServicesCard = ({ to, src, title, brief_description }) => {
//   const [imageLoaded, setImageLoaded] = useState(false);
//   const handleImageLoad = () => {
//     setImageLoaded(true);
//   };
  
//   return (
//     <div className="!w-full flex items-center justify-start my-2 border-b-[1px] pb-4">
//       <Link to={to}>
//         <img
//           src={src}
//           className={`${
//             !imageLoaded
//               ? "!w-0 !h-0"
//               : "!min-w-[110px] !min-h-[90px] !max-w-[110px] !max-h-[90px] !rounded-[10px] !object-contain hover:!scale-105"
//           }`}
//           alt={title}
//           onLoad={handleImageLoad}
//         />
//       </Link>
//       {!imageLoaded && (
//         <Skeleton
//           variant="rectangular"
//           height={100}
//           sx={{
//             backgroundColor: "rgba(255, 255, 255, 0.63)",
//             width: "7rem",
//             minWidth: "7rem",
//           }}
//         />
//       )}
//       <div className="flex flex-col pl-4 text-left">
//         <Link to={to}>
//           <p className="text-[#FDCF00] text-[20px] leading-5 mb-2 hover:text-[#f1d177]">
//             {title}
//           </p>
//         </Link>
//         <p className="!pt-3 text-white text-[14px] leading-4 line-clamp-3">
//           {brief_description}
//         </p>
//       </div>
//     </div>
//   );
// };
// export default ServicesCard;

import { useState } from "react";
import { Link } from "react-router-dom";
import { Skeleton } from "@mui/material";

const ServicesCard = ({ to, src, title, brief_description }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const handleImageLoad = () => {
    setImageLoaded(true);
  };
  
  return (
    <Link 
      to={to} 
      className="!w-full group relative bg-white/5 backdrop-blur-sm rounded-xl hover:!border-[#FDCF00] border-2 border-transparent overflow-hidden transition-all duration-300 flex items-center justify-start p-4 gap-4"
    >
      <div className="relative flex-shrink-0">
        {!imageLoaded && (
          <Skeleton
            variant="rectangular"
            height={100}
            width={110}
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              minWidth: "110px",
            }}
          />
        )}
        <img
          src={src}
          className={`${
            !imageLoaded
              ? "!w-0 !h-0"
              : "!min-w-[110px] !min-h-[90px] !max-w-[110px] !max-h-[90px] !rounded-[10px] !object-contain transition-transform duration-300 group-hover:scale-105"
          }`}
          alt={title}
          onLoad={handleImageLoad}
        />
      </div>
      <div className="flex flex-col text-left">
        <p className="text-white text-[20px] leading-5 mb-2 group-hover:text-[#FDCF00] transition-colors duration-300 font-semibold">
          {title}
        </p>
        <p className="text-gray-400 text-[14px] leading-4 line-clamp-3">
          {brief_description}
        </p>
      </div>
      
      {/* Hover overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#FDCF00]/5 to-purple-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
    </Link>
  );
};

export default ServicesCard;
